import { render } from "./MessageList.vue?vue&type=template&id=3d60fe1d&scoped=true&ts=true"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"

import "./MessageList.vue?vue&type=style&index=0&id=3d60fe1d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d60fe1d"]])

export default __exports__